import React from "react";
import useClientConfig from "../../../../../config/careers/clientConfig";


const CarbizBanner = () => {
  const { clientAssetsLink } = useClientConfig();

  const values = [
    {
      title: "Love what we do",
      description:
        "We’re passionate about delivering for our customers, team and partners every time.",
      image:
        clientAssetsLink + "/love-what-we-do-carbiz.webp",
      alt: "Love What We do",
    },
    {
      title: "Better than yesterday",
      description: "We grow each day, learning from our experiences.",
      image:
        clientAssetsLink + "/better-than-yesterday-carbiz.webp",
      alt: "Better Than Yesterday",
    },
    {
      title: "Win with trust",
      description: "Lead the market by being trusted, reliable and helpful.",
      image: clientAssetsLink + "/win-with-trust-carbiz.webp",
      alt: "Win with Trust",
    },
    {
      title: "Valuing people",
      description:
        "We respect our people, encourage their development and reward their performance.",
      image: clientAssetsLink + "/value-people-carbiz.webp",
      alt: "Valuing People",
    },
    {
      title: "Collaborative core",
      description: "Together we are smarter.",
      image:
        clientAssetsLink + "/collaborative-core-carbiz.webp",
      alt: "Collaborative Core",
    },
  ];

  return (
    <>
      <section className="cbz-values flex join-wrapper">
        <div className="cbz-image-left">
          <img
            src={clientAssetsLink + "/julie-and-family-carbiz.webp"}
            alt="Carbiz Careers"
          />
        </div>
        <div className="cbz-right-content">
          <header className="cbz-values__header">
            <h1>Find your dream job at Carbiz</h1>
            <p>
              At Carbiz, our mission is to be there for every Australian driver when they need it most.
            </p>
            <p>
              As we work to reach as many drivers as possible, we are equally committed to providing our team with a place where they can grow, make a difference and experience the deep satisfaction of helping others for a living.
            </p>
          </header>
        </div>
      </section>
      <section className="cbz-values" aria-labelledby="cbz-values-title">
        <div className="cbz-values__container">
          <header className="cbz-values__header">
            <h2 id="cbz-values-title">Our values</h2>
            <p>
              At Carbiz, our values guide everything we do. They’re what set us apart and
              drive us to be and do better, every day.
            </p>
          </header>

          <div className="cbz-values__grid">
            {values.map((value) => (
              <article className="cbz-value-card" key={value.title}>
                <img src={value.image} alt={value.alt} loading="lazy" />
                <div className="cbz-value-card__content">
                  <h3>{value.title}</h3>
                  <p>{value.description}</p>
                </div>
              </article>
            ))}
          </div>

          {/* <div className="cbz-values__cta">
            <p>Like the sound of what we stand for? We’d love to have you on our team.</p>
            <a href="#">View All Jobs</a>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default CarbizBanner;